/**
 * Environment Configuration
 * Centralizes all environment-specific settings
 */

const environment = {
  // API Base URLs
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://srop-staging-func.azurewebsites.net/api',
  
  // Environment name
  ENV: import.meta.env.VITE_ENV || 'development',
  
  // Feature flags
  ENABLE_DEBUG: import.meta.env.VITE_ENABLE_DEBUG === 'true',
  
  // Razorpay configuration
  RAZORPAY_KEY_ID: import.meta.env.VITE_RAZORPAY_KEY_ID || '',

  // Eazybuzz configuration
  EAZYBUZZ_KEY: import.meta.env.VITE_EAZYBUZZ_KEY || '',
  EAZYBUZZ_ENV: import.meta.env.VITE_EAZYBUZZ_ENV || 'test',

  // App info
  APP_NAME: 'ServiceHive Dashboard',
  APP_VERSION: '1.0.0',
};

// API Endpoints
export const API_ENDPOINTS = {
  // Health
  HEALTH: '/health',
  
  // Auth
  AUTH_LOGIN: '/v1/auth/login',
  AUTH_REGISTER: '/v1/auth/register',
  AUTH_ME: '/v1/auth/me',
  
  // Trips
  TRIPS_REGISTER: '/v1/trips/register',
  TRIPS_DEREGISTER: (tripId) => `/v1/trips/${tripId}`,
  OCCUPANCY_UPDATE: '/v1/occupancy/update',
  
  // Dashboard
  DASHBOARD_OVERVIEW: '/v1/dashboard/overview',
  DASHBOARD_RECOMMENDATIONS: '/v1/dashboard/recommendations',
  DASHBOARD_TRIPS: '/v1/dashboard/trips',
  DASHBOARD_ANALYTICS: '/v1/dashboard/analytics',
  
  // Billing
  BILLING_SUBSCRIPTION: '/v1/billing/subscription',
  BILLING_SUMMARY: '/v1/billing/summary',
  BILLING_CURRENT_CHARGES: '/v1/billing/current-charges',
  BILLING_USAGE: '/v1/billing/usage',
  BILLING_INVOICES: '/v1/billing/invoices',
  BILLING_TOPUP: '/v1/billing/topup',
  BILLING_TOKEN_BALANCE: '/v1/billing/token-balance',

  // Admin Billing
  ADMIN_BILLING_PLANS: '/v1/admin/billing/plans',
  ADMIN_BILLING_PLAN: (clientId) => `/v1/admin/billing/plans/${clientId}`,

  // Debug (for demo)
  DEBUG_PRICE_TRIP: '/debug/price-trip',
  DEBUG_LIST_TRIPS: '/debug/list-trips',
  DEBUG_TEST_ENGINE: '/debug/test-engine',

  // Invoices
  INVOICES: '/invoices',
  INVOICE_DOWNLOAD: (invoiceId) => `/invoices/${invoiceId}/download`,

  // Payments
  PAYMENT_GATEWAYS: '/v1/payments/gateways',
  PAYMENT_CREATE_ORDER: '/v1/payments/create-order',
  PAYMENT_VERIFY: '/v1/payments/verify',

  // Admin Invoice Management
  ADMIN_INVOICE_CONFIG: (clientId) => `/v1/admin/billing/${clientId}/invoice-config`,
  ADMIN_GENERATE_INVOICE: (clientId) => `/v1/admin/billing/${clientId}/generate-invoice`,
  ADMIN_PREVIEW_INVOICE: (clientId) => `/v1/admin/billing/${clientId}/preview-invoice`,
};

// Helper to check environment
export const isDevelopment = () => environment.ENV === 'development';
export const isProduction = () => environment.ENV === 'production';
export const isStaging = () => environment.ENV === 'staging';

export default environment;

